import { render } from "./RunCart.vue?vue&type=template&id=6a8d1b2a"
import script from "./RunCart.vue?vue&type=script&lang=js"
export * from "./RunCart.vue?vue&type=script&lang=js"
script.render = render

export default script